<div class="custom-header">
  <span>{{periodLabel}}</span>
</div>
